import { useRootWorkplaceByChildQuery } from '../../../graphql/graphql';
import { useAppContext } from '../../../Services/AppContext';

export default function useRootWorkplaceInfo() {
	const rootWorkplace = useRootWorkplaceByChildQuery({
		workplaceId: useAppContext().workplaceId,
	});

	const rootWorkplaceData = rootWorkplace?.data?.workplace?.rootWorkplace;
	const workplaceData = rootWorkplace?.data?.workplace;

	return {
		isLoading: rootWorkplace.isLoading,
		rootWorkplace: {
			id: rootWorkplaceData?.id!,
			name: rootWorkplaceData?.name!,
			address: rootWorkplaceData?.address?.fullAddress!,
		},
		workplace: {
			id: workplaceData?.id!,
			name: workplaceData?.name!,
			address: workplaceData?.address?.fullAddress!,
		},
	};
}
